import type { UserAccountType } from "@/models/user-account-type.model";
import { showAlertCallout } from "@/shared/alerts";
import { useUserRepository } from "@/shared/contexts/repository-context";
import { getGetUserListPaginatedQueryKey } from "@/spz-api/user/user";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export const useUpdateUserAccountType = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const userRepository = useUserRepository();

  const { mutate, isPending } = useMutation<
    void,
    Error,
    { userId: string; accountType: UserAccountType }
  >({
    mutationFn: async ({ userId, accountType }) => {
      return userRepository.updateUserAccountType(userId, accountType);
    },
    onSuccess: () => {
      showAlertCallout({
        type: "success",
        title: t("account_type_updated_successfully"),
      });
      queryClient.invalidateQueries({
        queryKey: getGetUserListPaginatedQueryKey({}),
      });
    },
    onError: () => {
      showAlertCallout({
        type: "critical",
        title: t("error_updating_account_type"),
      });
    },
  });

  return { updateUserAccountType: mutate, isPending };
};
